<template>
  <div class="columns is-multiline tableWithPerPageSelection">
    <div class="column is-4 is-offset-8 has-text-right">
      <div class="columns">
        <div class="column is-7 has-text-weight-bold
        has-text-default mgt-7px">
          {{ $t('indexation.taux') }}
        </div>
        <b-input v-model="taux"
                 class="column is-2 pdl-0"
                 type="number">
        </b-input>
        <div class="column is-3 pdl-0">
          <qd-button class="is-addOrEdit is-fullwidth"
                    :class="{ 'button-access-no-permission'
               : indexationYearSelect === null}"
                    :disabled="indexationYearSelect === null"
                    @click="indexationRegieTab.length === 0 ?
                    generationIndexationTiers() : popUpGenerationIndexationTiers = true">
            {{$t('general.button.generate')}}
          </qd-button>
        </div>
      </div>
    </div>
    <div class="column is-12" v-if="indexationRegieTab">
      <v-client-table v-model="indexationRegieTab"
                      class="stickyOnlyOnFirstTr
                      VueTableInputPaddingless
                      vueTableFilterStyle"
                      :columns="columns"
                      :options="options"
                      ref="tabRegie">
        <template slot='afterTable'>
          <table-items-in-view @input="$refs.tabRegie.setLimit($event)" />
        </template>
        <div slot="nomCommercial" slot-scope="props" class="pd-5px">
          <span>{{ props.row.nomCommercial }}</span>
          <span v-if="props.row.haveSpe"
                class="has-text-warning is-size-7 mgl-20px"
          >
            {{ $t('indexation.regie.tab.tauxPerso') }}
          </span>
        </div>
        <div slot="beforeYearSelect" slot-scope="props" class="pd-5px has-text-right">
          {{ props.row.valueYearBeforeSelect }}
        </div>
        <div slot="yearSelect" slot-scope="{row, update}">
          <input-currency :peutEtreNegatif="true"
                          v-model="row.valueYearSelect "
                          @input="update; updateIndexationTiersValue(row)"
                          isNumber="true">
          </input-currency>
        </div>
        <div slot="spe" slot-scope="props" class="has-text-centered pd-5px">
          <a @click="openPopUpSpe(props.row.tiersId, props.row.nomCommercial)"
             :class="{ 'disabled' : props.row.valueYearSelect === null}">
            <b-icon icon="file-search"
                    :class="{'text-access-no-permission' : props.row.valueYearSelect === null}"
                    type="is-primary">
            </b-icon>
          </a>
        </div>
      </v-client-table>
    </div>
    <b-modal v-model="popUpGenerationIndexationTiers"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="$t('indexation.regie.popUpGeneration.title')"
        :messDescription="$t('indexation.regie.popUpGeneration.sousTitle')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @yes="generationIndexationTiers"
        @no="popUpGenerationIndexationTiers = false"
      />
    </b-modal>
    <b-modal v-model="popUpIndexationSpeTiers"
             has-modal-card
             class="modal">
      <pop-up-specialisation-tiers :tiers="infoTiersForSpe"
                                   :societe-id="societeId"
                                   :liste-specialisation-tiers="indexationSpeTiers"
                                   @updateSpecialisationTiers="updateSpecialisationTiers">
      </pop-up-specialisation-tiers>
    </b-modal>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import genererTabIndexationTiers from '@/services/parametrage/indexation/genererTabIndexationTiers';
import {
  RESULTS_PER_PAGE,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import PopUpPrevention from '@/components/general/popUpPrevention';
import { TIERS_TYPE_FOURNISSEUR, TIERS_TYPE_CLIENT } from '@/configuration/tiers/tiersConf';
import { generateIndexationTiers } from '@/api/indexation';
import PopUpSpecialisationTiers
  from '@/components/parametrage/indexation/onglet/regie/p_specialisationTiers';
import TableItemsInView from '@/components/general/TableItemsInView';
import inputCurrency from '@/components/general/inputCurrency';

export default {
  name: 'IndexationRegie',
  props: {
    indexationYearSelect: {
      type: Object,
      required: false,
    },
    indexationPreviousYearSelect: {
      type: Object,
      required: false,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      indexationRegieTab: null,
      taux: 0,
      popUpGenerationIndexationTiers: false,
      indexationSpeTiers: [],
      popUpIndexationSpeTiers: false,
      infoTiersForSpe: null,
    };
  },
  components: {
    PopUpPrevention,
    PopUpSpecialisationTiers,
    TableItemsInView,
    inputCurrency,
  },
  computed: {
    columns() {
      if (!this.indexationPreviousYearSelect) return ['nomCommercial', 'yearSelect', 'spe'];
      return ['nomCommercial', 'beforeYearSelect', 'yearSelect', 'spe'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          nomCommercial: this.$i18n.t('indexation.regie.tab.regie'),
          spe: '',
          beforeYearSelect: this.indexationPreviousYearSelect
            ? (this.$i18n.t('indexation.regie.tab.taux', { year: this.indexationPreviousYearSelect.annee })) : null,
          yearSelect: this.indexationYearSelect ? (this.$i18n.t('indexation.regie.tab.taux', { year: this.indexationYearSelect.annee })) : null,
        },
        filterable: ['nomCommercial'],
        filterByColumn: true,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        sortable: ['nomCommercial', 'beforeYearSelect', 'yearSelect'],
        columnsClasses: {
          beforeYearSelect: 'colonneWidth130px',
          yearSelect: 'colonneWidth130px',
          spe: 'colonneSelected',
        },
        editableColumns: ['yearSelect'],
        uniqueKey: 'tiersId',
        customSorting: {
          yearSelect(ascending) {
            const sortMethod = (a, b) => {
              if (ascending) return Number(a.valueYearSelect) <= Number(b.valueYearSelect) ? -1 : 1;
              return Number(a.valueYearSelect) >= Number(b.valueYearSelect) ? -1 : 1;
            };
            return sortMethod;
          },
          beforeYearSelect(ascending) {
            const sortMethod = (a, b) => {
              if (ascending) {
                return Number(a.valueYearBeforeSelect) <= Number(b.valueYearBeforeSelect) ? -1 : 1;
              }
              return Number(a.valueYearBeforeSelect) >= Number(b.valueYearBeforeSelect) ? -1 : 1;
            };
            return sortMethod;
          },
        },
      };
    },
  },
  methods: {
    openPopUpSpe(tiersId, nomCommercial) {
      this.infoTiersForSpe = null;
      this.indexationSpeTiers = [];
      this.indexationSpeTiers = cloneDeep(
        this.indexationYearSelect.indexationTiers.filter((ind) => {
          return ind.tiersId === tiersId && ind.specialisationTiersId !== null;
        })
          .map((ind) => {
            return {
              specialisationTiersId: ind.specialisationTiersId,
              specialisationTiersNomCom: ind.specialisationTiers.nomCommercial,
              taux: ind.pourcentageIndexationParDefaut,
              isSearch: false,
            };
          }),
      );
      this.infoTiersForSpe = {
        tiersId: tiersId,
        nomCommercial: nomCommercial,
      };
      this.popUpIndexationSpeTiers = true;
    },
    updateIndexationTiersValue(indexationTiers) {
      const indexFind = this.indexationRegieTab.find((ind) => {
        return ind.tiersId === indexationTiers.tiersId;
      });
      indexFind.valueYearSelect = indexationTiers.valueYearSelect;
      this.$emit('updateIndexationTiersValue', indexationTiers.valueYearSelect, indexationTiers.tiersId);
    },
    updateSpecialisationTiers(listeIndexationTiersSpe) {
      const indexFind = this.indexationRegieTab.find((ind) => {
        return ind.tiersId === this.infoTiersForSpe.tiersId;
      });
      indexFind.haveSpe = listeIndexationTiersSpe.length > 0;
      this.$emit('updateSpecialisationTiers', this.infoTiersForSpe, listeIndexationTiersSpe);
      this.popUpIndexationSpeTiers = false;
    },
    async generationIndexationTiers() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          societeId: this.societeId,
          indexationId: this.indexationYearSelect.id,
          pourcentageIndexationParDefaut: this.taux,
          tiersType: TIERS_TYPE_FOURNISSEUR,
          sousType: [],
        };
        const indexationTiers = (await generateIndexationTiers(params)).data.result;
        this.$emit('replaceAllIndexationTiers', indexationTiers, TIERS_TYPE_CLIENT);
        loadingComponent.close();
        this.popUpGenerationIndexationTiers = false;
      } catch (e) {
        this.$emit('gestionErreur', e);
        this.popUpGenerationIndexationTiers = false;
        loadingComponent.close();
        throw e;
      }
    },
    async updateValueBase() {
      this.indexationRegieTab = null;
      this.indexationRegieTab = await genererTabIndexationTiers(
        cloneDeep(this.indexationYearSelect),
        cloneDeep(this.indexationPreviousYearSelect),
        TIERS_TYPE_FOURNISSEUR,
      );
    },
  },
  async mounted() {
    await this.updateValueBase();
    this.indexationRegieTab.sort((a, b) => {
      if (a.haveSpe && !b.haveSpe) return -1;
      if (!a.haveSpe && b.haveSpe) return 1;
      return 0;
    });
  },
};

</script>
